import { DefaultTheme } from 'styled-components';

export const darkTheme: DefaultTheme = {
  fontColor: '#fefefe',
  borderColor: '#fefefe',
  errorColor: 'darkred',
  mainColor: '#2ab494',
  helpTextColor: '#bdbdbd',
  tableLineColor: '#383e49',
  tableHeadColor: '#21252b',
  backgroundColor: '#282c34',
  backgroundModalColor: 'rgba(40,44,52,0.78)',
  backgroundContentModalColor: '#383e49',
};
